import { memo } from "react";
import { TextArea } from "ui/components/TextField/TextArea";
import { InvoiceIncomingNotesProps } from "./types";

const InvoiceIncomingNotes: React.FC<InvoiceIncomingNotesProps> = ({ note }) => {
  if (!note) return null;

  return (
    <div className="mt-3">
      <TextArea
        name="note"
        label="Napomena"
        value={note}
        disabled
      />
    </div>
  );
};

export default memo(InvoiceIncomingNotes);
